import { render, staticRenderFns } from "./EmptyAssignedRoute.vue?vue&type=template&id=0c7aa85e&"
import script from "./EmptyAssignedRoute.vue?vue&type=script&lang=js&"
export * from "./EmptyAssignedRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports